module.exports = __webpack_public_path__ + "img/icon_food_store.940af88f.png";